module.exports = __webpack_public_path__ + "static/media/Hunter.bfe3a15a.svg";